module.exports = __webpack_public_path__ + "static/img/zb1-1.1e64098.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/zb1-1.png
// module id = 729
// module chunks = 0